import { BaseSlipSelection } from "../BaseSlipSelection";
import { BaseSlipSelectionType } from "../index";

export type QASlipSelectionType = {
    eventDate: Date;
    lineTypeId: number;
    betTypeId: number;
    useEventName: string;
    eventName: string;
    lineName: string;
    asianLineName: string;
    mappedLineTypeId: number;
    swapped: boolean;
    splitTypeId: number;
    SISEventId: number;
    GBSEventId: number;
    feedEventId: number;
    feedProviderId: number;
    isEachWayEnabled?: boolean;
    placeTermsId?: number;
    eachWayTermsId?: number;
    relatedToId: number;
    eachWayMaxStake?: number;
    eachWayMaxStakeCombo?: number;
    eachWayComboBetIsEnabled?: boolean;
    eachWayMinBet?: number;
    // absolute game start time in seconds
    qaParameter1: number;
    // the duration of the period in seconds
    qaParameter2: number;
} & BaseSlipSelectionType;

export class QASlipSelection extends BaseSlipSelection {
    eventDate: Date;
    lineTypeId: number;
    betTypeId: number;
    useEventName: string;
    eventName: string;
    lineName: string;
    asianLineName: string;
    mappedLineTypeId: number;
    swapped: boolean;
    splitTypeId: number;
    SISEventId: number;
    GBSEventId: number;
    feedEventId: number;
    feedProviderId: number;
    isEachWayEnabled?: boolean;
    placeTermsId?: number;
    eachWayTermsId?: number;
    relatedToId: number;
    eachWayMaxStake?: number;
    eachWayMaxStakeCombo?: number;
    eachWayComboBetIsEnabled?: boolean;
    eachWayMinBet?: number;
    qaParameter1: number;
    qaParameter2: number;

    constructor(source: QASlipSelectionType) {
        super(source);
        this.eventDate = source.eventDate;
        this.lineTypeId = source.lineTypeId;
        this.betTypeId = source.betTypeId;
        this.useEventName = source.useEventName;
        this.eventName = source.eventName;
        this.lineName = source.lineName;
        this.asianLineName = source.asianLineName;
        this.mappedLineTypeId = source.mappedLineTypeId;
        this.swapped = source.swapped;
        this.splitTypeId = source.splitTypeId;
        this.SISEventId = source.SISEventId;
        this.GBSEventId = source.GBSEventId;
        this.feedEventId = source.feedEventId;
        this.feedProviderId = source.feedProviderId;
        this.isEachWayEnabled = source.isEachWayEnabled;
        this.placeTermsId = source.placeTermsId;
        this.relatedToId = source.relatedToId;
        this.eachWayMaxStake = source.eachWayMaxStake;
        this.eachWayMaxStakeCombo = source.eachWayMaxStakeCombo;
        this.eachWayComboBetIsEnabled = source.eachWayComboBetIsEnabled;
        this.eachWayMinBet = source.eachWayMinBet;
        this.qaParameter1 = source.qaParameter1;
        this.qaParameter2 = source.qaParameter2;
    }
}
